import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import Button from 'modules/_shared/components/Buttons';
import { useCanjeModal } from '../context/CanjeModalContext';

const CanjeModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useCanjeModal();

  const hasValidDate =
    data.date && data.date >= data.lastOperationDate && data.ratioOld >= 1;

  const step1Enabled = data.scriptureView && hasValidDate;

  const step2Enabled =
    !data.scriptureView &&
    !!data.targetSocietyId &&
    !!data.selectedHoldingClass &&
    !data.previewErrorKey &&
    data.previewParticipants.length > 0 &&
    data.selectedParticipantIds.length > 0;

  const buttonText = data.scriptureView ? t('Next') : t('SaveOperation');

  return (
    <Modal.Footer className="bg-white">
      <Button
        text={buttonText}
        disabled={data.isLoading || (!step1Enabled && !step2Enabled)}
        onClick={actions.handleSaveCanje}
        lgSize
      />
    </Modal.Footer>
  );
};

export default CanjeModalFooter;
